/**
 * This controller is used to help a customer make an order.
 */
(function() {
    'use strict';

    angular.module('app').controller('OrderController', OrderController);

    function OrderController(
        $http,
        $scope,
        $routeParams,
        $timeout,
        $window,
        productCategory,
        Upload,
        CartFactory,
        FontFactory,
        HolidayFactory,
        MetadataFactory,
        ShippingParserFactory,
        FilterFactory,
        DesignFactory
    ) {
        $scope.product = productCategory;
        $scope.productOptions = productCategory.product;
        $scope.styles = productCategory.styles;
        $scope.fonts = FontFactory.query();
        $scope.cart = CartFactory;
        $scope.cartStatus = false;
        $scope.styleLimit = 'All';
        $scope.shareLink = '...Loading...';
        $scope.shareTitle = null;
        $scope.shareImage = null;
        $scope.linkCopied = false;
        $scope.orderedKeychains = null;
        $scope.showCart = showCart;
        $scope.hideCart = hideCart;
        $scope.setShippingIndex = setShippingIndex;
        $scope.populate = populate;
        $scope.convertToSlug = convertToSlug;
        $scope.selectDefaultSize = selectDefaultSize;
        $scope.resetColors = resetColors;
        $scope.cartItemsQty = cartItemsQty;
        $scope.distributePromo = distributePromo;
        $scope.sendTagEvent = sendTagEvent;
        $scope.toggleStyleLimit = toggleStyleLimit;
        $scope.active_campaign = false;
        $scope.orderProcessStageEvents = {
            'page_load' : false,
            'quantity_selected' : false,
            'message_entered' : false,
            'date_selected' : false
        };
        $scope.bandColorHasQty = bandColorHasQty;
        $scope.keychainCheck = keychainCheck;
        $scope.windowWidth = $window.innerWidth;        
        $scope.isMobile = false;
        $scope.found = 0;
        $scope.activeStatus = false;
        $scope.resetShippingIndex = resetShippingIndex;
        $scope.shippingHold = '';
        $scope.key = [0,0,0,0];
        populate();
        initializeBandConfig();


        $timeout(
            function() {
                sendTagEvent('page_load');
            }
        );

        $scope.init = function(){
            $scope.isMobile = ($scope.windowWidth) < 640 ? true : false;
            if($scope.isMobile)
                $scope.band.colorGroupsFilter = 'Solid';
            else
                $scope.band.colorGroupsFilter = 'All';
        };

    
        //Listen for window scale change-- mobile rotation
        angular.element($window).bind('resize', function(){
            $scope.windowWidth = $window.innerWidth;

            // Browser width check for mobile devices-- 
            // corresponds w/ vert/horiz scroll shift
            if($scope.windowWidth < 640) {
                $scope.isMobile = true;
                if($scope.band.colorGroupsFilter == null || $scope.band.colorGroupsFilter === '')
                // Since hiding All as def, set group filter to solid when in mobile scale
                $scope.band.colorGroupsFilter = 'Solid';
            } else {
                $scope.isMobile = false;
            }

            $scope.$digest();
            $scope.$apply();
        });

        // Browser width check for mobile devices-- 
        // corresponds w/ vert/horiz scroll shift
        if(window.innerWidth < 640) {
            $scope.isMobile = true;
            if($scope.band.colorGroupsFilter == null || $scope.band.colorGroupsFilter === '')
            // Since hiding All as def, set group filter to solid when in mobile scale
            $scope.band.colorGroupsFilter = 'Solid';
        }

        function sendTagEvent(stage) {
            if (!$scope.orderProcessStageEvents[stage]) {
                gtag('event', stage, {'event_category': 'Order Process'});
                $scope.orderProcessStageEvents[stage] = true;
            }
        }

        function toggleStyleLimit() {
            $scope.styleLimit = $scope.styleLimit === 4 ? 'All' : 4;
        }

        //init metadata
        $scope.metadata = MetadataFactory.get({'models[]': [
            'Length'
        ]});

        // Holidays are required by the shipping parser.
        HolidayFactory.index().$promise.then(onHolidaySuccess);
        $('.o-loading').fadeOut('fast');
        // Activate optimizely
        if (typeof window.optimizely !== 'undefined' && $scope.product.optimizely_test !== undefined &&
            typeof $scope.product.optimizely_test !== 'undefined' && $scope.product.optimizely_test !== null) {
            window.optimizely.push({
                type: "page",
                pageName: $scope.product.optimizely_test
            });
        }

        /**
         * Passes the provided holidays to the shipping parser factory to get the function for parsing shipping. Then
         * passes that function to an initialization function so the order qty function can be attached.
         *
         * @param {Object} response An object containing the company holidays.
         */
        function onHolidaySuccess(response) {
            onShippingSuccess(ShippingParserFactory.get(response));
        }

        /**
         * When provided with a function for parsing shipping information, attaches a function for determining the
         * ordered qty to the scope as well as adds a function for calculating the sub total. The later is done because
         * a sub total can not be calculated without the shipping information.
         *
         * @param {ShippingParser~parseShipping} shippingParser The method used for parsing shipping.
         */
        function onShippingSuccess(shippingParser) {
            // @todo need to find a better place for this.
            $(document).foundation();

            $scope.$watch('orderPage.qty.ordered', onQtyChange);
            $scope.$watch('product.size', onSizeChange);
            $scope.calcSubtotal = calcSubtotal;
            // Initialize the shipping info.
            $scope.shippingInfo = shippingParser(
                $scope.product.style.shipping,
                $scope.orderPage.qty.ordered,
                $scope.product.style.name,
                $scope.product.size.width.name
            );

            function onQtyChange(newValue, oldValue) {
                // Update shipping
                $scope.shippingInfo = shippingParser(
                    $scope.product.style.shipping,
                    $scope.orderPage.qty.ordered,
                    $scope.product.style.name,
                    $scope.product.size.width.name
                );

                resetMinimumOptions(newValue);

                if (newValue >= $scope.orderPage.free.minimumOrder && $scope.product.name !== 'Tyvek') {
                    $scope.orderPage.qty.free = $scope.orderPage.free.qty;
                    distributePromo();
                } else {
                    $scope.orderPage.qty.free = null;
                }
            }

            function onSizeChange() {
                if (typeof $scope.productOptions.options['Keychains'] !== 'undefined' &&
                    $scope.productOptions.options['Keychains'].field.value &&
                    $scope.product.size.width.name !== '1/2 Inch') {
                    $scope.productOptions.options['Keychains'].field.value = null;
                    $scope.calcOptionsCost('Keychains');
                }

                // Update shipping
                $scope.shippingInfo = shippingParser(
                    $scope.product.style.shipping,
                    $scope.orderPage.qty.ordered,
                    $scope.product.style.name,
                    $scope.product.size.width.name
                );
            }

            function calcSubtotal() {
                var costEach = 0;

                // Base Cost from Pricing Table
                if ($scope.product === undefined || $scope.product.size === undefined) {
                    return;
                } else {
                    angular.forEach($scope.product.size.pricing, function(qty) {
                        if (qty.start <= $scope.orderPage.qty.ordered) {
                            costEach = qty.price;
                        }
                    });
                }
                // Upsell for Complex Color Group Band
                var complexColorUpsell = false;
                angular.forEach($scope.product.style.color_groups, function(group) {
                    angular.forEach(group.colors, function(color) {
                        if (color.qty) {
                            if (group.name === 'Swirl' || group.name === 'Segmented' || group.name === 'Glow') {
                                complexColorUpsell = true;
                            } else {
                                complexColorUpsell = false;
                            }
                        }
                    });
                });
                if (complexColorUpsell === true) {
                    
                    costEach = costEach + 0.01;
                }

                // Add cost to clipart
                var hasClipart = false;
                angular.forEach($scope.band.cliparts, function(clipart) {
                    if (clipart.id) {
                        hasClipart = true;
                    }
                });
                if (hasClipart) {
                    costEach = costEach + $scope.calcOptionsPrice('Clipart');
                }
                if (typeof $scope.band.messages.Inside !== 'undefined' &&
                    $scope.band.messages.Inside.text) {
                    costEach = costEach + $scope.calcMessagePrice('Inside');
                }
                var currLayout = $scope.band.messageLayout;

                // Upsell for Message Char Length
                angular.forEach($scope.band.messages, function(message, layout) {
                    if(message.text && (message.layout === 'front-back' || message.layout === 'all')){
                        if(message.layout === currLayout)
                        {
                            if ( layout === 'Front' || layout === 'Back' ) {
                                if (message.text.length >= message.upsellCharLength) {
                                    costEach = costEach + message.upsellCost;
                                }
                            }
                        }
                    }
                    else if (message.text && message.layout === 'wrap-around') {
                        if(message.layout === currLayout)
                        {
                            if (message.text.length >= message.upsellCharLength) {
                                costEach = costEach + message.upsellCost;
                            }
                        }
                    }
                });
                // check if the keychain option got selected.
                if($scope.productOptions.keychainOption !== null && $scope.productOptions.keychainOption &&
                    typeof $scope.productOptions.keychainOption !== 'undefined'){

                    // Only get the shipping price if a shipping option has been selected.
                    costEach = costEach + $scope.orderPage.cost.options + parseFloat(
                            $scope.shippingIndex === null ? 0 : $scope.shippingInfo[$scope.shippingIndex].price
                        );
                    costEach = costEach + (($scope.orderedKeychains * $scope.orderPage.cost.keychainEach )/
                        $scope.orderPage.qty.ordered);
                    if(isNaN(costEach))
                        costEach = 0;

                    $scope.orderPage.cost.each = costEach;
                    return $scope.orderPage.qty.ordered * costEach;

                }else{
                    // Only get the shipping price if a shipping option has been selected.
                    costEach = costEach + $scope.orderPage.cost.options + parseFloat(
                            $scope.shippingIndex === null ? 0 : $scope.shippingInfo[$scope.shippingIndex].price
                        );

                    $scope.orderPage.cost.each = costEach;

                    return $scope.orderPage.qty.ordered * costEach;
                }
            }
        }

        function msgIsEmpty()
        {
            var $nonemptyMsgCounter = 0;
            var $nonemptyIconCounter = 0;
            angular.forEach($scope.band.messages, function(message) {
                if(message.text !== undefined)
                {
                    $nonemptyMsgCounter++;
                }
            });
            angular.forEach($scope.band.cliparts, function(cliparts) {
                if(cliparts.id !== null)
                {
                    $nonemptyIconCounter++;
                }
            });

            if($nonemptyMsgCounter ||  $nonemptyIconCounter )
            {
                return 0;
            }
            else
            {
                return 1;
            }
        }

        function setShippingIndex(index) {
            $scope.sendTagEvent('date_selected');
            $scope.shippingIndex = index;

            if ($scope.shippingInfo[index].name && $scope.shippingInfo[index].name === 'Expedited') {
                $scope.removeOption('Custom Individual Bagging');
                $scope.removeOption('Thicker');
                $scope.removeOption('Keychains');
                $scope.orderPage.cost.options = 0;
                $scope.orderPage.qty.free = 200;
                $scope.band.messages.Inside.text = '';
                $scope.orderPage.keychains = null;

            } else if ($scope.orderPage.qty.ordered >= $scope.orderPage.free.minimumOrder && $scope.product.name !== 'Tyvek') {
                $scope.orderPage.qty.free = $scope.orderPage.free.qty;
            }
        }

        function resetShippingIndex() {
            $scope.shippingIndex = null;
        }

        /**
         * This function will handle the custom bagging logo file uploads
         * @param file
         * @param errFiles
         */
        $scope.uploadCustomBagLogo = function (file, errFiles) {
            $scope.customBagLogo = file;
            $scope.customBaggingErrFile = errFiles[0];

            if (file) {
                file.upload = Upload.upload({
                    url: '/customBagging/upload',
                    method: 'POST',
                    file: file,
                    sendFieldsAs: 'form',
                });

                file.upload.then(function (response) {
                        $timeout(function () {
                            file.result = response.data;
                            $scope.productOptions.options['Custom Individual Bagging'].image = file.result.fileName;
                        });
                    },

                    function (response) {

                    },

                    function (evt) {
                        file.progress = Math.min(100, parseInt(100.0 *
                            evt.loaded / evt.total));
                    }
                );
            }
        };

        /**
         * This method will handle returning the clipart item depending on what is passed on to it
         *
         * @param {string} clipArtValue  this the clipart value
         * @return will either return the same clipart value or the clipart value for the uploading
         * clipart place holder
         */
        $scope.returnClipArt = function (clipArtValue) {
            if (clipArtValue === undefined || typeof clipArtValue === 'undefined' || clipArtValue === null) {
                return false;
            }
            if (clipArtValue.match(/^(\d*)$/)) {
                return clipArtValue;
            } else {
                // This is the id for the upload place holder
                return '16953';
            }
        };

        /**
         * Opens custom clipart modal and closes clipart modal
         * @param  {string} slug clipart position
         */
        $scope.openCustomClipartModal = function(slug) {
            $('#' + slug).foundation('close');
            $('#' + slug + '-custom').foundation('open');
        };

        /**
         * Close custom clipart modal and opens clipart modal
         * @param  {string} slug clipart position
         */
        $scope.closeCustomClipartModal = function(slug) {
            $('#' + slug + '-custom').foundation('close');
            $('#' + slug).foundation('open');
        };

        /**
         * This function will handle the custom clipart file uploads
         * @param file
         * @param errFiles
         * @param title
         */
        $scope.uploadCustomClipArt = function (file, errFiles, title, slug) {
            $scope.customClipArt = file;
            $scope.clipArtErrFile = errFiles[0];

            if (file) {
                file.upload = Upload.upload({
                    url: '/clipArt/upload',
                    method: 'POST',
                    file: file,
                    sendFieldsAs: 'form',
                    fields: {
                        position: title
                    }
                });

                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.band.cliparts[title].id = file.result.fileName;
                        $scope.orderHasCustomClipart = true;

                        // On success
                        if (file.result.code == 200) {
                            // Clear the clipart data.
                            $scope.customClipArt = null;
                            $('#' + slug + '-custom').foundation('close');
                        }

                    });
                }, function (response) {

                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 *
                        evt.loaded / evt.total));
                });
            }
        };

        /**
         * Whenever the clipart ids have been change, this function will handle updating and injecting the svg data
         * instead of using the other retrieveSVG function that was used previously
         * The reason for this is so that it can work with the model
         *
         */
        $scope.updateClipart = function (id, position) {
            id = $scope.returnClipArt(id);

            if (!id) {
                return;
            }

            $http.get('/clipArt/' + id + '.svg')
                .success(function (output) {
                    $('#' + position + '-preview').html(output);
                });
        };


        if($scope.product.name != 'Tyvek') {
            
            // The items below are the watches for clipart id. on change the clipart svg data will be updated
            $scope.$watch('band.cliparts["Front Start"].id', function (newVal, oldVal) {
                if (newVal !== null || oldVal !== null) {
                    $scope.updateClipart($scope.band.cliparts["Front Start"].id, 'front-start');
                }
            }, true);

            $scope.$watch('band.cliparts["Front End"].id', function (newVal, oldVal) {
                if (newVal !== null || oldVal !== null) {
                    $scope.updateClipart($scope.band.cliparts["Front End"].id, 'front-end');
                }
            }, true);

            $scope.$watch('band.cliparts["Back Start"].id', function (newVal, oldVal) {
                if (newVal !== null || oldVal !== null) {
                    $scope.updateClipart($scope.band.cliparts["Back Start"].id, 'back-start');
                }
            }, true);

            $scope.$watch('band.cliparts["Back End"].id', function (newVal, oldVal) {
                if (newVal !== null || oldVal !== null) {
                    $scope.updateClipart($scope.band.cliparts["Back End"].id, 'back-end');
                }
            }, true);
        }
        $scope.$watch('band.cliparts["Wrap Around Start"].id', function(newVal, oldVal) {
            if (newVal !== null || oldVal !== null) {
                $scope.updateClipart($scope.band.cliparts["Wrap Around Start"].id, 'wrap-around-start');
            }
        }, true);

        $scope.$watch('band.cliparts["Wrap Around End"].id', function(newVal, oldVal) {
            if (newVal !== null || oldVal !== null) {
                $scope.updateClipart($scope.band.cliparts["Wrap Around End"].id, 'wrap-around-end');
            }
        }, true);

        $scope.calcOptionsPrice = function (option, ordered) {
            var optionsPrice = 0;
            var orderedQty = typeof(ordered) !== 'undefined' ? ordered : $scope.orderPage.qty.ordered;

            if (orderedQty < 1) {
                orderedQty = 1;
            }

            if (
                $scope.productOptions !== undefined && $scope.productOptions.options !== undefined &&
                $scope.productOptions.options[option] !== undefined
            ) {
                // Base Cost from Pricing Table
                angular.forEach($scope.productOptions.options[option].pricing, function(qty) {
                    if (qty.start > orderedQty) {
                        return;
                    }
                    optionsPrice = qty.price;
                });
            }
            var coupon = $scope.cart.coupon;
            if(coupon.status === "Active" && coupon.type === "options" && option ==='Individual Bagging' &&
                orderedQty >= coupon.order_minimum)
            {
                $scope.productOptions.options['Individual Bagging'].field.value = true;
                return 0;
            }

            return optionsPrice;
        };

        $scope.calcMessagePrice = function(message) {
            var optionsPrice = 0;
            var orderedQty = $scope.orderPage.qty.ordered;

            if (orderedQty < 1) { orderedQty = 1; }
            if(typeof $scope.productOptions.options.messages.options[message] !== 'undefined'){
                angular.forEach($scope.productOptions.options.messages.options[message].pricing, function(qty) {
                    if (qty.start > orderedQty) {
                        return;
                    }
                    optionsPrice = qty.price;
                });
            }
            return optionsPrice;
        };

        $scope.calcOptionsCost = function(option) {
            var optionsCost = $scope.orderPage.cost.options;
            if ($scope.productOptions.options[option].field.value) {
                optionsCost = optionsCost + $scope.calcOptionsPrice(option);
            } else {
                optionsCost = optionsCost - $scope.calcOptionsPrice(option);
            }
            $scope.orderPage.cost.options = optionsCost > 0 ? optionsCost : 0 ;
        };

        $scope.calcKeychainCost = function(keychainOption, extra) {
            if(keychainOption) {
                keychainCheck(extra);
            } else {
                removeKeychainPrice();
            }
        };

        $scope.removeOption = function(option) {
            if ($scope.productOptions.options[option] !== undefined && $scope.productOptions.options[option].field.value) {
                $scope.orderPage.cost.options = $scope.orderPage.cost.options - $scope.calcOptionsPrice(option);
                $scope.productOptions.options[option].field.value = false;
            }
            if(option === 'Keychains')
            {
                if($scope.productOptions.keychainOption === true)
                {
                    $scope.productOptions.keychainOption = false;
                    if($scope.orderPage.cost.options)
                    {
                        $scope.orderPage.cost.options = $scope.orderPage.cost.options - $scope.calcOptionsPrice(option);
                    }
                    else
                        $scope.orderPage.cost.options = 0;
                    $scope.productOptions.options[option].field.value = false;
                }
            }
        };

        function removeKeychainPrice(){
            $scope.orderPage.cost.keychainEach = 0;
            $scope.orderedKeychains = null;
            $scope.calcSubtotal();
        }

        function addKeychainPrice(){
            if($scope.orderedKeychains > 0 && $scope.orderedKeychains !== null &&
            typeof $scope.orderedKeychains !== 'undefined'){
                $scope.orderPage.cost.keychainEach = $scope.calcOptionsPrice('Keychains');
            }
        }

        function keychainCheck(extra) {
            $scope.errorAdditional = false;

            if( extra !== null && extra >= $scope.orderPage.minKeychain &&
                typeof extra !== 'undefined' &&
                extra <= ($scope.orderPage.qty.ordered + $scope.orderPage.qty.free)) {
                $scope.orderedKeychains = extra;
            }else {
                $scope.errorAdditional = true;
                $scope.orderedKeychains = $scope.orderPage.minKeychain;
            }

            addKeychainPrice();
        }

        $scope.activateColor = function(colorGroup, colorGroupKey, color) {
            if (bandColorHasQty(color)) {
                $scope.band.activeColorColorGroup = colorGroup;
                $scope.band.activeColor = color;
            } else {
                $scope.band.activeColorColorGroup = $scope.product.style.color_groups[0].name;
                $scope.band.activeColor = $scope.product.style.colors[0];
            }
        };

        $scope.previewStyle = function() {
            var previewStyle = '';
            if ($scope.band.activeColorColorGroup !== null) {
                previewStyle = 'o-preview__side--' +
                $scope.convertToSlug($scope.band.activeColorColorGroup) +
                '-' + $scope.band.activeColor.values.length;
            }
            return previewStyle;
        };

        $scope.flippedIcon = function(position) {
            var flippedIcon = '';
            if ($scope.band.cliparts[position].flipped === true ) {
                flippedIcon = 'js-flipped';
            } else {
                flippedIcon = '';
            }
            return flippedIcon;
        };

        $scope.changeActiveTextColor = function(color) {
            $scope.band.activeColor.textColor = color;
        };


        $scope.previewUrlFrontStart = function(color) {
            var preview = encodeURIComponent(
                $scope.band.messageLayout + '+colors+' + color.id + '+text+' + color.textColor +
                '-' + $scope.productOptions.options.fontsize.field.value + '-' +
                $scope.productOptions.options.font.field.value +
                '+content+' + $scope.band.cliparts['Front Start'].id + '-' +
                $scope.band.cliparts['Front Start'].flipped + '-' + $scope.band.messages.Front.text + '-' +
                $scope.band.cliparts['Front End'].id + '-' + $scope.band.cliparts['Front End'].flipped + '--' +
                $scope.band.cliparts['Back Start'].id + '-' + $scope.band.cliparts['Back Start'].flipped + '-' +
                $scope.band.messages.Back.text + '-' + $scope.band.cliparts['Back End'].id + '-' +
                $scope.band.cliparts['Back End'].flipped + '--' + $scope.band.messages.Inside.text + '-outside-' +
                $scope.product.style.name + '.jpg');
            preview = String(preview);
            preview = preview.replace(/undefined/g, '');
            preview = preview.replace(/null/g, '');
            return preview;
        };

        $scope.previewUrlWrapAround = function(color) {
            var preview = encodeURIComponent(
                $scope.band.messageLayout + '+colors+' + color.id + '+text+' + color.textColor +
                '-' + $scope.productOptions.options.fontsize.field.value + '-' +
                $scope.productOptions.options.font.field.value +
                '+content+' + $scope.band.cliparts['Wrap Around Start'].id + '-' +
                $scope.band.cliparts['Wrap Around Start'].flipped + '-' + $scope.band.messages['Wrap Around'].text +
                '-' + $scope.band.cliparts['Wrap Around End'].id + '-' +
                $scope.band.cliparts['Wrap Around End'].flipped + '--' + (
                    typeof $scope.band.messages.Inside !== 'undefined' && $scope.band.messages.Inside.text ?
                        $scope.band.messages.Inside.text : '') + '-outside-' + $scope.product.style.name + '.jpg');
            preview = String(preview);
            preview = preview.replace(/undefined/g, '');
            preview = preview.replace(/null/g, '');
            return preview;
        };

        $scope.previewUrlInside = function(color) {
            var preview = encodeURIComponent(
                $scope.band.messageLayout + '+colors+' + color.id + '+text+' + color.textColor + '-' +
                $scope.productOptions.options.fontsize.field.value + '-' +
                $scope.productOptions.options.font.field.value +
                '+content+' + $scope.band.cliparts['Front Start'].id + '-' +
                $scope.band.cliparts['Front Start'].flipped + '-' + $scope.band.messages.Front.text + '-' +
                $scope.band.cliparts['Front End'].id + '-' + $scope.band.cliparts['Front End'].flipped + '--' +
                $scope.band.cliparts['Back Start'].id + '-' + $scope.band.cliparts['Back Start'].flipped + '-' +
                $scope.band.messages.Back.text + '-' + $scope.band.cliparts['Back End'].id + '-' +
                $scope.band.cliparts['Back End'].flipped + '--' + $scope.band.messages.Inside.text +'-inside-' +
                $scope.product.style.name + '.jpg');
            preview = String(preview);
            preview = preview.replace(/undefined/g, '');
            preview = preview.replace(/null/g, '');
            return preview;
        };

        document.getShareLink = function () {
            var params = {
                type: convertToSlug($scope.product.style.name),
                size: $scope.product.size.width.unit,
                messageStyle: $scope.band.messageLayout,
                messageFront: $scope.band.messages['messageFront'] === 'undefined' ? 'undefined' : $scope.band.messages['Front'].text,
                messageBack: $scope.band.messages['messageBack'] === 'undefined' ? 'undefined' : $scope.band.messages['Back'].text,
                messageWrapAround: $scope.band.messages['messageWrapAround'] === 'undefined' ? 'undefined' : $scope.band.messages['Wrap Around'].text,
                messageInside: $scope.band.messages['messageInside'] === 'undefined' ? 'undefined' : $scope.band.messages['Inside'].text,
                frontStart: $scope.band.cliparts['frontStart'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Front Start'].id,
                frontEnd: $scope.band.cliparts['frontEnd'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Front End'].id,
                backStart: $scope.band.cliparts['backStart'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Back Start'].id,
                backEnd: $scope.band.cliparts['backEnd'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Back End'].id,
                frontStartFlipped: $scope.band.cliparts['frontStartFlipped'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Front Start'].flipped,
                frontEndFlipped: $scope.band.cliparts['frontEndFlipped'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Front End'].flipped,
                backStartFlipped: $scope.band.cliparts['backStartFlipped'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Back Start'].flipped,
                backEndFlipped: $scope.band.cliparts['backEndFlipped'] === 'undefined' ? 'undefined' : $scope.band.cliparts['Back End'].flipped,
                activeColorColorGroup: $scope.band.activeColorColorGroup,
                activeColor: $scope.band.activeColor.id,
                textColor: $scope.band.activeColor.textColor,
                font: $scope.productOptions.options['font'].field.value,
                fontSize: $scope.productOptions.options['fontsize'].field.value
                // referenceId: $scope.productOptions.options['referenceid'] === 'undefined' ? 'undefined' : ($scope.productOptions.options['referenceid'].field === 'undefined' ? '' : $scope.productOptions.options['referenceid'].field.value)
            };

            return $.param(params);
        };

        $scope.createShareLink = function() {
            $scope.linkCopied = false;
            $scope.shareLink = '...Loading...';

            $('#share-link-modal').foundation('open');

            var linkParams = document.getShareLink();
            var uris = {};

            if ($scope.band.messageLayout === 'front-back' || $scope.band.messageLayout === 'wrap-around') {
                uris['outside'] = $scope.previewUrlFrontStart($scope.band.activeColor);
            }

            if (typeof $scope.band.messages.Inside !== 'undefined' && $scope.band.messages.Inside.text) {
                uris['inside'] = $scope.previewUrlInside($scope.band.activeColor);
            }

            var design = {uris: uris, long: linkParams};

            DesignFactory.save(design).$promise.then(openShareLinkModal);

            function openShareLinkModal (response) {
                $scope.shareLink = response.short;
                $scope.shareTitle = encodeURIComponent(response.title);
                $scope.shareImage = response.image;
                // copyTextToClipboard(response.short);

            }
        };

        $scope.fallbackCopyTextToClipboard = function(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                $scope.linkCopied = successful;
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
        };

        $scope.copyTextToClipboard = function() {
            var text = $scope.shareLink;
            if (!navigator.clipboard) {
                $scope.fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function() {
                $scope.linkCopied = true;
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        };

        /**
         * Checks if band color has amount
         * @param {object} color
         * @return {boolean}
         */
        function bandColorHasQty(color) {
            if (typeof color.qty !== 'undefined' && typeof color.qty.amount !== 'undefined') {
                var total = 0;
                angular.forEach(color.qty.amount, addColorQuanity);

                if(total > 0 ){
                    return true;
                }
            }
            return false;

            function addColorQuanity(colorAmount) {
                total += colorAmount.paid;
            }
        }

        /**
         * Creates a 'item' object for the order.
         */
        $scope.addLineItem = function() {
            $scope.item = {};
            $scope.item.description = $scope.product.style.name+" Wristband";
            $scope.item.promotionalQuantity = $scope.orderPage.qty.free;
            $scope.item.price = $scope.orderPage.cost.each;

            $scope.item.setUpFee = msgIsEmpty() ? 0 : $scope.product.style.setup_fee;

            $scope.item.custom_fields = {};
            var customFields = $scope.item.custom_fields;
            customFields.style = {};
            customFields.style.name  = 'Style';
            customFields.style.value = $scope.product.style.name;
            customFields.size = {};
            customFields.size.name  = 'Size';
            customFields.size.value = $scope.product.size.width.name;
            var requisitionItem = {};
            var requisitionIndex = 0;
            angular.forEach($scope.product.style.colors, function(color) {
                if (bandColorHasQty(color)) {
                    var bandQtyIndex = color.color_group_name +' '+color.name+' Band';
                    customFields[bandQtyIndex] = {};
                    customFields[bandQtyIndex].name = bandQtyIndex;
                    customFields[bandQtyIndex].value = '';
                    angular.forEach(color.qty.amount, function(amount, key){
                        if(amount.paid !== null && typeof amount.paid !== 'undefined' && amount.paid > 0){
                            customFields[bandQtyIndex].value +=
                                key +' Qty: ' + amount.paid;
                            customFields[bandQtyIndex].value +=
                                $scope.item.promotionalQuantity ? ' + ' +
                                    amount.distributedPromoAmount + ' Free' : '';
                            customFields[bandQtyIndex].value += ', ';
                            requisitionItem[requisitionIndex] = {};
                            requisitionItem[requisitionIndex].qty = amount.paid;
                            requisitionItem[requisitionIndex].qty += $scope.item.promotionalQuantity ?
                                amount.distributedPromoAmount : 0;
                            requisitionItem[requisitionIndex].bandWidth = $scope.product.size.width.id;
                            requisitionItem[requisitionIndex].bandLength = $scope.metadata.Length.lengths[key].id;
                            requisitionItem[requisitionIndex].colorId = color.id;
                            requisitionIndex++;
                        }
                    });
                    customFields[bandQtyIndex].value +=
                        $scope.product.style.hasTextColor ? 'Text Color: ' + color.textColor : '';

                    var groupColorIndex = color.color_group_name+' '+color.name;
                    if ($scope.band.messageLayout === 'front-back') {
                        customFields['Preview Outside Front Back ' + groupColorIndex] = {
                          name : 'Preview Outside '+$scope.band.messageLayout+' '+groupColorIndex,
                          value : $scope.previewUrlFrontStart(color)
                        }
                    } else if ($scope.band.messageLayout === 'wrap-around') {
                        customFields['Preview Outside Wrap Around ' + groupColorIndex] = {
                          name : 'Preview Outside '+$scope.band.messageLayout+' '+groupColorIndex,
                          value : $scope.previewUrlWrapAround(color)
                        };
                    }

                    if (typeof $scope.band.messages.Inside !== 'undefined' && $scope.band.messages.Inside.text) {
                        customFields['Preview Inside ' + groupColorIndex] = {
                          name : 'Preview Inside '+$scope.band.messageLayout+' '+groupColorIndex,
                          value : $scope.previewUrlInside(color)
                        };
                    }
                }
            });

            angular.forEach($scope.band.messages, function(message, key) {
                if (message.text) {
                    if (message.layout == $scope.band.messageLayout || message.layout == 'all') {
                        customFields[key+' Message'] = {};
                        customFields[key+' Message'].name  = key+' Message';
                        customFields[key+' Message'].value = message.text;
                    }
                }
            });

            customFields.requisitionItem = {};
            customFields.requisitionItem.name = 'Requisition Item';
            customFields.requisitionItem.value = JSON.stringify(requisitionItem);

            customFields.font_face = {};
            customFields.font_face.name  = 'Font Face';
            customFields.font_face.value = $scope.productOptions.options.font.field.value;

            customFields.font_size = {};
            customFields.font_size.name  = 'Font Size';
            customFields.font_size.value = $scope.productOptions.options.fontsize.field.value;

            angular.forEach($scope.band.cliparts, function(clipart, title) {
                if (clipart.id && clipart.layout === $scope.band.messageLayout) {
                    customFields[title+'clipart_id'] = {};
                    customFields[title+'clipart_id'].name  = title+' Clipart ID';
                    customFields[title+'clipart_id'].value =
                        clipart.id + (clipart.flipped === true ? ' (flipped)' : '');
                }
            });

            angular.forEach($scope.productOptions.options, function(option, name) {
                if (option.field.value && ['font', 'fontsize', 'minfontsize', 'maxfontsize'].indexOf(name) === -1) {
                    if (name === 'Keychains' &&
                        $scope.product.size.width.name !== '1/2 Inch') {
                        $scope.productOptions.options['Keychains'].field.value = null;
                    } else{
                        customFields[name] = {};
                        customFields[name].name  = name+' Option';
                        customFields[name].value = 'Yes';
                    }

                }
            });

            if ($scope.productOptions.options['Custom Individual Bagging'] !== undefined &&
                $scope.productOptions.options['Custom Individual Bagging'].field.value) {
                customFields['Custom Individual Bagging Slogan'] = {};
                customFields['Custom Individual Bagging Slogan'].name = 'Custom Individual Bagging Slogan';
                customFields['Custom Individual Bagging Slogan'].value =
                    $scope.productOptions.options['Custom Individual Bagging'].slogan;
                customFields['Custom Individual Bagging Image'] = {};
                customFields['Custom Individual Bagging Image'].name = 'Custom Individual Bagging Image';
                customFields['Custom Individual Bagging Image'].value =
                    $scope.productOptions.options['Custom Individual Bagging'].image;
            }

            customFields.delivery_date = {};
            customFields.delivery_date.name  = 'Delivery Date';
            customFields.delivery_date.value = $scope.shippingInfo[$scope.shippingIndex].date.toDateString();

            if($scope.productOptions.keychainOption !== null && $scope.productOptions.keychainOption &&
                typeof $scope.productOptions.keychainOption !== 'undefined'){
                customFields[name] = {};
                customFields[name].name = 'Keychains Option';
                customFields[name].value = 'Yes. ' + $scope.orderedKeychains + ' Keychains Requested';
                removeKeychainPrice();
                $scope.productOptions.keychainOption = null;

            }

            angular.forEach($scope.productOptions.options, function(option, name) {
                if (option.field.value && ['font', 'fontsize', 'minfontsize', 'maxfontsize'].indexOf(name) === -1) {
                    $scope.removeOption(name);
                }
            });

            $scope.item.quantity = $scope.orderPage.qty.ordered;
            $scope.item.promotionalQuantity = $scope.orderPage.qty.free;

            $scope.cart.pushItem($scope.item);
            sendTagEvent('addedToCart');
            $scope.item = {};
            resetColors();
            populate();
            $scope.showCart();
        };

        function convertToSlug(Text) {
            if (Text === null) {
                return;
            }
            return Text
                .toLowerCase()
                .replace(/ /g,'-')
                .replace(/[^\w-]+/g,'');
        }
        function selectDefaultSize() {
            for (var i=0; i < $scope.product.style.sizes.length; i++) {
                if ($scope.product.style.default_size_id === $scope.product.style.sizes[i].id) {
                    $scope.product.size = $scope.product.style.sizes[i];
                    $scope.product.size_id = $scope.product.style.sizes[i].id;
                    $scope.selectedSize = $scope.product.style.sizes[i].name;
                }
            }
        }

        // @todo find a better solution for this - maybe adjusting the aggregateQuantity directive.

        function resetColors() {
            $scope.removeOption('Custom Individual Bagging');
            $scope.removeOption('Thicker');
            $scope.removeOption('Keychains');
            for (var j=0; j < $scope.product.style.colors.length; j++) {
                if ($scope.product.style.colors[j].qty) {
                    $scope.product.style.colors[j].qty = 0;
                }
            }
        }

        function resetMinimumOptions(orderedBands) {
            if( typeof $scope.productOptions.options['Thicker'] !== 'undefined' &&
                $scope.productOptions.options['Thicker'].field.value &&
                orderedBands < $scope.orderPage.minThickerBand) {
                $scope.productOptions.options['Thicker'].field.value = null;
                $scope.calcOptionsCost('Thicker');
            }

            if( typeof $scope.productOptions.options['Custom Individual Bagging'] !== 'undefined' &&
                $scope.productOptions.options['Custom Individual Bagging'].field.value &&
                orderedBands < $scope.orderPage.minCustomBag) {
                $scope.productOptions.options['Custom Individual Bagging'].field.value = null;
                $scope.calcOptionsCost('Custom Individual Bagging');
            }

            if( typeof $scope.band.messages.Inside !== 'undefined' &&
                $scope.band.messages.Inside.text && orderedBands < $scope.orderPage.minInsideMsg) {
                $scope.band.messages.Inside.text = '';
            }
        }

        /**
         * Counts how many color quantities are in the order (adult & youth)
         * @return {integer}
         */
        function countColorQtyLength() {
            var colorQtyLength = 0;
            var colors = $scope.product.style.colors;

            for (var c = 0; c < colors.length; c++) {
                if (typeof colors[c].qty !== 'undefined' &&
                    typeof colors[c].qty.amount !== 'undefined') {
                    angular.forEach(colors[c].qty.amount, countOfColorLength);
                }
            }

            function countOfColorLength(amount) {
                if (amount.paid > 0) {
                    colorQtyLength += 1;
                }
            }

            return colorQtyLength;
        }

        /**
         * Distributes promotion quantity to all band quantities in the order
         * @return {null} sets integer into angular quantity scope
        */
        function distributePromo() {
            $timeout(function() {
                var promoAmount = $scope.orderPage.free.qty;
                var colorQtyLength = countColorQtyLength();

                // Determine Remainder
                var promoRemainder = promoAmount % colorQtyLength;
                var distributedPromoAmount = Math.floor(promoAmount / colorQtyLength);

                var colors = $scope.product.style.colors;

                for (var c = 0; c < colors.length; c++) {
                    if (typeof colors[c].qty !== 'undefined' &&
                        typeof colors[c].qty.amount !== 'undefined') {
                        angular.forEach(colors[c].qty.amount, distributionOfPromo);
                    }
                }

                function distributionOfPromo(amount) {
                    if (amount.paid > 0) {
                        amount.distributedPromoAmount = distributedPromoAmount;
                        if (promoRemainder > 0) {
                            amount.distributedPromoAmount++;
                            promoRemainder--;
                        }
                    }
                }
            });
        }

        function initializeBandConfig() {
            // Set the style if it was provided in the route.
            if (typeof $routeParams.type !== "undefined") {
                for (var i=0; i < $scope.styles.length; i++) {
                    if ($routeParams.type === convertToSlug($scope.styles[i].name)) {
                        $scope.product.style = $scope.styles[i];
                        $scope.product.style_id = $scope.styles[i].id;

                        // Set the size if it was provided in the route.
                        if (typeof $routeParams.size !== "undefined") {
                            for (var j=0; j < $scope.product.style.sizes.length; j++) {
                                if ($routeParams.size === $scope.product.style.sizes[j].width.unit) {
                                    $scope.product.size = $scope.product.style.sizes[j];
                                    $scope.product.size_id = $scope.product.style.sizes[j].id;
                                    $scope.selectedSize = $scope.product.style.sizes[j].name;

                                    break;
                                }
                            }

                            // Set the message if it was provided in the route.
                            if (typeof $routeParams.messageStyle !== "undefined") {
                                $scope.band.messageLayout = $routeParams.messageStyle;

                                var messageDetails = {
                                    'messageFront' : 'Front',
                                    'messageBack' : 'Back',
                                    'messageWrapAround' : 'Wrap Around',
                                    'messageInside' : 'Inside'
                                };

                                angular.forEach(messageDetails, function (message, route) {
                                    if (typeof $routeParams[route] !== "undefined") {
                                        $scope.band.messages[message].text = $routeParams[route];
                                    }
                                });

                                var clipart = {
                                    'frontStart' : 'Front Start',
                                    'frontEnd' : 'Front End',
                                    'backStart' : 'Back Start',
                                    'backEnd' : 'Back End'
                                };

                                angular.forEach(clipart, function (message, route) {
                                    if (typeof $routeParams[route] !== "undefined") {
                                        $scope.band.cliparts[message].id = $routeParams[route];
                                    }
                                });

                                var clipartFlipped = {
                                    'frontStartFlipped' : 'Front Start',
                                    'frontEndFlipped' : 'Front End',
                                    'backStartFlipped' : 'Back Start',
                                    'backEndFlipped' : 'Back End'
                                };

                                angular.forEach(clipartFlipped, function (message, route) {
                                    if (typeof $routeParams[route] !== "undefined") {
                                        $scope.band.cliparts[message].flipped = (
                                            $routeParams[route] === true ? true : ($routeParams[route] === "true")
                                        );
                                    }
                                });

                                if (typeof $routeParams.activeColorColorGroup !== "undefined") {
                                    $scope.band.activeColorColorGroup = $routeParams.activeColorColorGroup;
                                }

                                if (typeof $routeParams.activeColor !== "undefined") {
                                    angular.forEach($scope.product.style.colors, function (color, i) {
                                       if (color.id === eval($routeParams.activeColor)) {
                                           if (typeof $routeParams.textColor !== "undefined") {
                                               color.textColor = $routeParams.textColor;
                                               $scope.textColor = $routeParams.textColor;
                                           }

                                           $scope.band.activeColor = color;

                                           // Default to 100 (presumably adult) wristbands
                                           var amount = {};
                                           amount[$scope.product.style.lengths[0].name] = {paid : 100, free : 200};
                                           $scope.product.style.colors[i].qty = {amount : amount};
                                           $scope.orderPage.qty.ordered = 100;
                                       }
                                    });
                                }

                                if (typeof $routeParams.font !== "undefined") {
                                    $scope.productOptions.options['font'] = {'field' : {'value' : $routeParams.font}}
                                }

                                if (typeof $routeParams.fontSize !== "undefined") {
                                    $scope.productOptions.options['fontsize'] = {'field' : {'value' : $routeParams.fontSize}}
                                }
                            }

                        } else {
                            selectDefaultSize();
                        }

                        break;
                    }
                }
            } else {
                for (var k=0; k < $scope.styles.length; k++) {
                    if ($scope.product.default_size.style.id === $scope.styles[k].id) {
                        $scope.product.style = $scope.styles[k];
                        $scope.product.style_id = $scope.styles[k].id;

                        selectDefaultSize();
                    }
                }
            }
        }

        function populate() {
            $scope.shippingIndex = null;
            $scope.shippingInfo = [];
            $scope.textColor = '#ffffff';
            $scope.orderPage = {
                minInsideMsg: 100,
                minThickerBand: 100,
                minCustomBag: 100,
                minKeychain: 25,
                expedited: false,
                free: {
                    minimumOrder: 100,
                    qty: 200,
                },
                qty: {
                    ordered: 0,
                    free: 0,
                    total: 0,
                },
                cost: {
                    each: 0,
                    options: 0,
                    delivery: 0,
                },
            };

            $scope.band = {
                colorGroupsFilter: "All",
                activeColor: $scope.styles[0]['colors'][0],
                activeColorColorGroup: null,
                messageLayout: 'wrap-around',
                // @todo replace this with dynamic product model.
                messages: {
                    'Wrap Around': {
                        maxCharLength: 80,
                        upsellCharLength: 35,
                        upsellCost: 0.03,
                        layout: 'wrap-around'
                    }
                },
                clipartSearchResults: null,
                cliparts: {
                    'Wrap Around Start': {
                        slug: 'wrap-around-start',
                        layout: 'wrap-around',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    },
                    'Wrap Around End': {
                        slug: 'wrap-around-end',
                        layout: 'wrap-around',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    }
                }
            };

            if($scope.product.name !== 'Tyvek'){
                $scope.band.messageLayout = 'front-back';
                $scope.siliconeMessageExtend = {
                    'Front': {
                        maxCharLength: 40,
                        upsellCharLength: 25,
                        upsellCost: 0.03,
                        layout: 'front-back'
                    },
                    'Back': {
                        maxCharLength: 40,
                        upsellCharLength: 25,
                        upsellCost: 0.03,
                        layout: 'front-back'
                    },
                    'Inside': {
                        maxCharLength: 80,
                        upsellCharLength: 35,
                        upsellCost: 0.00,
                        layout: 'all'
                    }
                };
                $.extend( true, $scope.band.messages, $scope.siliconeMessageExtend );

                $scope.siliconeClipartExtend = {
                    'Front Start': {
                        slug: 'front-start',
                        layout: 'front-back',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    },
                    'Front End': {
                        slug: 'front-end',
                        layout: 'front-back',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    },
                    'Back Start': {
                        slug: 'back-start',
                        layout: 'front-back',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    },
                    'Back End': {
                        slug: 'back-end',
                        layout: 'front-back',
                        hasClipart: false,
                        flipped: false,
                        id: null,
                        svg: null
                    }
                };
                $.extend( true, $scope.band.cliparts, $scope.siliconeClipartExtend );
            }
        }

        /**
         * Calculates total quantity of order in cart
         * @return {integer}
         */
        function cartItemsQty() {
            var qty = 0;
            angular.forEach($scope.cart.items, function(item) {
                qty += item.quantity;
            });
            return qty;
        }

        function showCart() {
            $scope.cartStatus = true;
        }

        function hideCart(clickEvent) {
            if ($(clickEvent.target).is('.cart-sidebar')) {
                $scope.cartStatus = true;
            } else if ($(clickEvent.target).is('.cart-sidebar__back')) {
                $scope.cartStatus = false;
            } else if ($(clickEvent.target).parents().is('.cart-sidebar')) {
                $scope.cartStatus = true;
            } else {
                $scope.cartStatus = false;
            }
        }
    }

})();
